export class RestoreGceDiskConfig {
    'zone';
    'diskType';
    'diskSizeBytes';
    'description';
    'labels';
    'iops';
    'throughput';
    'encryptionKeyId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "zone",
            "baseName": "zone",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskType",
            "baseName": "diskType",
            "type": "string",
            "format": ""
        },
        {
            "name": "diskSizeBytes",
            "baseName": "diskSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "labels",
            "baseName": "labels",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "iops",
            "baseName": "iops",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "throughput",
            "baseName": "throughput",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGceDiskConfig.attributeTypeMap;
    }
    constructor() {
    }
}
